import React from 'react';

// Types
import { OnboardingFlowType } from './types';

// Hooks
import { useOnboardingState } from 'Shared/utils/hooks/use-onboarding-state';

import DesktopOnboardingWizard from './DesktopOnboardingWizard/DesktopOnboardingWizard';
import MobileOnboardingWizard from './MobileOnboardingWizard/MobileOnboardingWizard';
import MarketingThirdPartyBrowswerSignup from './MarketingThirdPartyBrowswerSignup/MarketingThirdPartyBrowswerSignup';
import OnboardingSlackAI from '../OnboardingSlackAI/OnboardingSlackAI';

function OnboardingWizard() {
  const { flowType, showInAppBrowserScreen } = useOnboardingState();
  const isMobileFlow =
    flowType === OnboardingFlowType.mobile || flowType === OnboardingFlowType.mobileCalendarIntegration;
  if (showInAppBrowserScreen) return <MarketingThirdPartyBrowswerSignup />;
  if (flowType === OnboardingFlowType.agendaAi) return <OnboardingSlackAI />;
  if (isMobileFlow) return <MobileOnboardingWizard />;
  return <DesktopOnboardingWizard />;
}

export default OnboardingWizard;
